import { Component, Prop, Watch, State, Listen, Element, Host, h } from '@stencil/core';
import { gsap } from 'gsap';
gsap.config({
  // suppress warnings when selector targets don't exist
  nullTargetWarn: false,
});

@Component({
  tag: 'fls-hero',
  styleUrl: 'fls-hero.scss',
  shadow: false,
  // scoped: true, //** scope the styles only to the component */
})
export class FlsHero {
  @Element() el!: HTMLElement;
  @Prop() layout: string = 'default';

  @Listen('resize', { target: 'window' })
  handleResize(/* ev */) {
    this.getScreenSize();
  }

  @State() isMediumScreen: boolean = true;
  @Watch('isMediumScreen')
  // @ts-ignore
  watchStateHandler(newValue: number[], oldValue: number[]) {
    this.animateImage();
  }

  getScreenSize() {
    const mql = window.matchMedia('(min-width: 768px)');
    this.isMediumScreen = mql.matches;
  }

  componentWillLoad() {
    this.getScreenSize();
  }

  animateImage() {
    const tl = gsap.timeline();
    const q = gsap.utils.selector(this.el);

    tl.from(
      // photo position
      q('.fls-hero-photo'),
      {
        duration: 1,
        x: '-=50',
      },
      0,
    )
      // photo opacity
      .from(
        q('.fls-hero-photo'),
        {
          duration: 0.25,
          opacity: 0,
          ease: 'easeOut',
        },
        '<',
      )
      // desktop background shapes
      .from(
        q('.background-desktop g > *'),
        {
          duration: 1,
          opacity: 0,
          x: '+=10',
          stagger: 0.2,
          // stagger: { amount: 1 },
        },
        '<',
      )
      // mobile background shapes
      .from(
        q('.background-mobile g > *'),
        {
          duration: 1,
          opacity: 0,
          x: '+=10',
          stagger: 0.1,
        },
        '<',
      );
    // .duration(1.8); // total animation duration
    // .from(
    //   q('.background-shapes > *'),
    //   {
    //     opacity: 0,
    //     x: '+=10',
    //     stagger: 0.15,
    //   },
    //   '-=0.3',
    // )
    // .duration(1);
  }

  handleImageLoad = event => {
    let container = this.el.querySelector('.fls-hero');
    container.classList.remove('is-loading');
    this.animateImage();
    if (event?.target) {
      event.target.removeEventListener('load', this.handleImageLoad);
      event.target.removeEventListener('error', this.handleImageLoad);
    }
  };

  getBackgroundMobile() {
    switch (this.layout) {
      case 'home':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMax" width="390.491" height="333.721" viewBox="0 0 390.491 333.721">
            <g data-name="group" transform="translate(-58.449)">
              <rect width="100%" height="333.721" transform="translate(58.45)" fill="#00324a" fill-opacity="0" />
              <rect width="100%" height="83.43" transform="translate(264.381 167)" fill="#00405b" />
              <rect width="100%" height="83.43" transform="translate(264.381 250.291)" fill="#2b6480" />
              <rect width="100%" height="166.861" transform="translate(264.381 333.721) rotate(180)" fill="#e36c5c" />
              <path
                data-name="semicircle"
                d="M114.334,114.335A114.334,114.334,0,0,0,228.668,0H0A114.334,114.334,0,0,0,114.334,114.335Z"
                transform="translate(418.761 166.861) rotate(180)"
                fill="#f7e0db"
              />
              <path data-name="triangle" d="M98.589,98.589H0V0Z" transform="translate(91.503 109.75)" fill="#b1deee" />
            </g>
          </svg>
        );
      case 'landing':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" class="img-fluid" preserveAspectRatio="xMidYMax" width="340" height="141" viewBox="0 0 340 141">
            <g class="stagger-in">
              <path data-name="teal triangle" d="M1230.4,46.521,1183.744,0H965.07l125.59,125.222h75.224L1230.4,60.893" transform="translate(-910.793 15.743)" fill="#2b6480" />
              <rect data-name="dark blue square" width="118.5" height="141" transform="translate(221.5)" fill="#12143d" />
              <path data-name="light blue triangle" d="M1217.54,0l93.808,91.6L1429.856.115V0Z" transform="translate(-1089.856)" fill="#a6ddef" />
              <path
                data-name="periwinkle half circle"
                d="M1058.885,212.02a80.254,80.254,0,0,0-80.255,80.255h160.514a80.254,80.254,0,0,0-80.255-80.255"
                transform="translate(-924.353 -151.275)"
                fill="#7c98ec"
              />
            </g>
          </svg>
        );

      default:
        return [
          <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMaxYMin" class="img-fluid" width="488" height="350" viewBox="0 0 488 350">
            <g class="stagger-in">
              <rect
                data-name="medium angle"
                width="240.454"
                height="598"
                style={{ height: '150vh' }}
                transform="matrix(-0.666, 0.746, -0.746, -0.666, 606.978, 217.944)"
                fill="#1b526a"
              />
              {/* <path
                id="dark_circle"
                data-name="dark circle"
                d="M1476.75,558.834c-102.035,0-184.75,82.715-184.75,184.75h369.5c0-102.035-82.715-184.75-184.75-184.75"
                transform="translate(-1251.132 -393.584)"
                fill="#07102f"
              /> */}
            </g>
          </svg>,
          <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMaxYMax" class="img-fluid" width="488" height="350" viewBox="0 0 488 350">
            <g class="stagger-in">
              {/* <rect
              data-name="medium angle"
              width="240.454"
              height="598"
              style={{ height: '150vh' }}
              transform="matrix(-0.666, 0.746, -0.746, -0.666, 606.978, 217.944)"
              fill="#1b526a"
            /> */}
              <path
                id="dark_circle"
                data-name="dark circle"
                d="M1476.75,558.834c-102.035,0-184.75,82.715-184.75,184.75h369.5c0-102.035-82.715-184.75-184.75-184.75"
                transform="translate(-1251.132 -393.584)"
                fill="#07102f"
              />
            </g>
          </svg>,
        ];
    }
  }

  getBackgroundDesktop() {
    switch (this.layout) {
      case 'home':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="758" height="704" viewBox="0 0 758 704">
            <g id="header-hero-bg-mask" transform="translate(-1162 -90)">
              <g id="Group_1650" data-name="Group 1650" transform="translate(0 -0.305)">
                <path id="Path_2" data-name="Path 2" d="M3605.058,677.675H3320V392.617Z" transform="translate(4766.777 765.806) rotate(180)" fill="#b1deee" />
                <rect id="Rectangle_1" data-name="Rectangle 1" width="473.208" height="360" transform="translate(1446.777 88.131)" fill="#e36c5c" />
                <path
                  id="Path_1"
                  data-name="Path 1"
                  d="M3158.686,511.126c130.681,0,236.619-105.938,236.619-236.619H2922.068C2922.068,405.188,3028.005,511.126,3158.686,511.126Z"
                  transform="translate(-1475.304 -186.376)"
                  fill="#f7e0db"
                />
                <rect id="Rectangle_3" data-name="Rectangle 3" width="852.012" height="1182.993" transform="translate(1124.488 41.312)" fill="none" />
                <rect id="Rectangle_2" data-name="Rectangle 2" width="654.123" height="541.123" transform="translate(1278.618 448.602)" fill="#00405b" />
              </g>
            </g>
          </svg>
        );
      case 'landing':
        return [
          <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMin" class="img-fluid" width="966" height="452" viewBox="0 0 966 452">
            <g class="stagger-in">
              <path id="teal_triangle" data-name="teal triangle" d="M565.877,558.339l-686.2-674.326L600.515-669.1l686.2,674.326Z" fill="#2b6480" />
              <rect id="dark_blue_square" data-name="dark blue square" style={{ height: '100vh' }} width="392.707" height="452" transform="translate(573.288)" fill="#12143d" />
              <path
                id="light_blue_triangle"
                data-name="light blue triangle"
                d="M573.306,304.782,181.478-80.267,593.085-396.1,984.913-11.055Z"
                transform="translate(0 -3.896)"
                fill="#a6ddef"
              />
              <path
                id="half-circle"
                d="M352.186,212.02c-132.54,0-239.98,107.44-239.98,239.98h479.97c0-132.54-107.44-239.98-239.98-239.98"
                transform="translate(-0.206 -452)"
                fill="#7c98ec"
              />
            </g>
          </svg>,
          <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMax" class="img-fluid" width="966" height="452" viewBox="0 0 966 452">
            <g class="stagger-in">
              <path
                id="half-circle"
                d="M352.186,212.02c-132.54,0-239.98,107.44-239.98,239.98h479.97c0-132.54-107.44-239.98-239.98-239.98"
                transform="translate(-0.206 -0.02)"
                fill="#7c98ec"
              />
            </g>
          </svg>,
        ];

      default:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMaxYMax" class="img-fluid" width="488" height="350" viewBox="0 0 488 350">
            <g class="stagger-in">
              <rect
                class="svg--medium_angle"
                data-name="medium angle"
                width="240.454"
                height="598"
                style={{ height: '150vh' }}
                transform="matrix(-0.666, 0.746, -0.746, -0.666, 606.978, 217.944)"
                fill="#1b526a"
              />
              <path
                id="dark_circle"
                data-name="dark circle"
                d="M1476.75,558.834c-102.035,0-184.75,82.715-184.75,184.75h369.5c0-102.035-82.715-184.75-184.75-184.75"
                transform="translate(-1251.132 -393.584)"
                fill="#07102f"
              />
            </g>
          </svg>
        );
    }
  }

  getLayout() {
    switch (this.layout) {
      case 'home':
        return (
          <div class="fls-hero-container container-xxl">
            <div class="row fls-hero-background justify-content-center align-items-end">
              <div slot="background" class="h-100 col-12 px-0 col-md-7 offset-md-7 offset-lg-8 offset-xl-10 position-relative">
                <div slot="background-mobile" class="background-mobile d-flex d-md-none align-items-end h-100">
                  {this.getBackgroundMobile()}
                </div>
                <div slot="background-desktop" class="background-desktop d-none d-md-block">
                  {this.getBackgroundDesktop()}
                </div>
                <div class="background-shapes d-none d-md-block">
                  <div class={`fls-hero-triangle fls-hero-triangle-1 flip-h`}></div>
                  <div class={`fls-hero-triangle fls-hero-triangle-2 flip-h`}></div>
                </div>
              </div>
            </div>
            <div class="row fls-hero-foreground justify-content-center flex-lg-nowrap">
              <div class="col-sm-11 col-md-7 col-lg-7 col-xl-9 offset-xl-3 align-self-center">
                <div class="fls-hero-content mx-3 mx-sm-4 mt-lg-0 ms-md-5 my-5 me-md-n5">
                  <slot></slot>
                </div>
              </div>
              <div class="fls-hero-photo-wrap col-12 col-md-5 col-lg-5 col-xl-6 align-self-center align-self-md-stretch">
                <div class="fls-hero-photo h-100 me-md-n5 me-xl-auto d-flex justify-content-center align-items-end align-items-sm-end align-items-xl-start">
                  <slot name="photo"></slot>
                </div>
              </div>
            </div>
          </div>
        );
      case 'landing':
        return (
          <div class="fls-hero-container container-xxl">
            <div class="row fls-hero-background justify-content-center justify-content-md-start justify-content-lg-center align-items-end">
              <div slot="background" class="h-100 col-12 px-0 col-md-8 offset-md-5 offset-lg-7 offset-xl-7 offset-xxl-9 position-relative">
                <div slot="background-mobile" class="background-mobile d-flex d-md-none align-items-end h-100">
                  {this.getBackgroundMobile()}
                </div>
                <div slot="background-desktop" class="background-desktop h-100 d-none d-md-flex flex-column align-items-end">
                  {this.getBackgroundDesktop()}
                </div>
                <div class="background-shapes d-none d-md-block">
                  <div class="fls-hero-triangle fls-hero-triangle-1 flip-h fls-hero-triangle-skew"></div>
                  <div class="fls-hero-triangle fls-hero-triangle-2 flip-h fls-hero-triangle-skew"></div>
                </div>
              </div>
            </div>
            <div class="row fls-hero-foreground flex-lg-nowrap">
              <div class="col-sm-11 col-md-6 col-lg-7 col-xl-8 col-xxl-9 align-self-center">
                <div class="fls-hero-content mx-4 ms-md-5 mb-3 mb-md-5 my-5 me-md-n5">
                  <slot></slot>
                </div>
              </div>
              <div class="fls-hero-photo-wrap col-12 col-md-6 col-lg-5 col-xl-6 align-self-center align-self-md-stretch pt-3 pt-md-0">
                <div class="fls-hero-photo h-100 me-md-n5 me-xl-auto d-flex justify-content-center align-items-end align-items-sm-end align-items-xl-start">
                  <slot name="photo"></slot>
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return (
          <div class="fls-hero-container container-xxl">
            <div class="row fls-hero-background justify-content-center justify-content-md-start justify-content-lg-center align-items-end">
              <div slot="background" class="h-100 px-0 col-7 offset-6 col-md-4 offset-md-8 offset-lg-8 offset-xl-8 offset-xxl-11 position-relative">
                <div slot="background-mobile" class="background-mobile d-flex d-md-none align-items-end h-100">
                  {this.getBackgroundMobile()}
                </div>
                <div slot="background-desktop" class="background-desktop h-100 d-none d-md-flex flex-column align-items-end">
                  {this.getBackgroundDesktop()}
                </div>
                <div class="background-shapes d-none d-md-block">
                  <div class="fls-hero-triangle fls-hero-triangle-1 flip-h fls-hero-triangle-skew"></div>
                  <div class="fls-hero-triangle fls-hero-triangle-2 flip-h fls-hero-triangle-skew"></div>
                </div>
              </div>
            </div>
            <div class="row fls-hero-foreground flex-lg-nowrap">
              <div class="col-11 col-md-10 align-self-center">
                <div class="fls-hero-content mx-4 ms-md-5 my-5 me-md-n5">
                  <div class="fls-hero-breadcrumb mb-3 mb-md-4">
                    <slot name="breadcrumb"></slot>
                  </div>
                  <slot></slot>
                </div>
              </div>
            </div>
          </div>
        );
    }
  }

  componentDidLoad() {
    const image: HTMLImageElement = this.el.querySelector('img');
    if (image && !image.complete) {
      image.addEventListener('load', this.handleImageLoad);
      image.addEventListener('error', this.handleImageLoad);
    } else {
      // TODO: handle local loading case without synthetic event
      this.handleImageLoad({} as Event);
    }

    const tl = gsap.timeline();
    const q = gsap.utils.selector(this.el);

    tl.add('start').from(
      q('.fls-hero-content > *'),
      {
        opacity: 0,
        y: '+=100',
        stagger: { amount: 0.2 },
      },
      'start',
    );
  }

  render() {
    return (
      <Host>
        <section class="fls-hero is-loading text-bg-primary text-white" data-layout={this.layout} aria-label="Introduction">
          {this.getLayout()}
        </section>
      </Host>
    );
  }
}
